<template>
  <section class="tech-icons">
    <span v-for="tech in this.tech" target="_blank">
      <b-tooltip multilined animated :label="tech.tooltip">
        <b-icon class="icon-spacing" size="is-large" :icon="tech.icon" :pack="tech.pack"></b-icon>
      </b-tooltip>
    </span>
  </section>
</template>

<script>
  import BIcon from "buefy/src/components/icon/Icon";
  import BTooltip from "buefy/src/components/tooltip/Tooltip";

  export default {
    name: "Technologies",
    components: {BTooltip, BIcon},
    data() {
      return {
        tech: [
          {"tooltip": "Symfony 4", "icon": "symfony", 'pack': 'mdi'},
          {"tooltip": "Vue.js", "icon": "vuejs", 'pack': 'mdi'},
          {"tooltip": "Docker, Docker Compose", "icon": "docker", 'pack': 'mdi'},
          {
            "tooltip": "Amazon Web Services: Route53, ECS, EC2, ECR, RDS. ecs-cli, ecs-cli compose, EKS (kubernetes)",
            "icon": "aws",
            'pack': 'fab'
          },
          {"tooltip": "Git. Github. GitLab.", "icon": "git", 'pack': 'mdi'},
          {"tooltip": "PHP7", "icon": "language-php", 'pack': 'mdi'},
          {
            "tooltip": "Python 3 with a little bit Flask and Django development",
            "icon": "language-python",
            'pack': 'mdi'
          },
          {"tooltip": "HTML5!", "icon": "language-html5", 'pack': 'mdi'},
          {"tooltip": "Scss, Pre-processed CSS", "icon": "sass", 'pack': 'mdi'}
        ]
      }
    },
    computed: {},
    methods: {}
  }
</script>
<style lang="scss" scoped>

   .b-tooltip.is-medium:after {
      max-width: 150px;
    }

</style>